<template>
  <success title="已提交撮合" :btn-list="btnData"></success>
</template>
<script>
import Success from '../components/Success'

export default {
  components: {
    Success
  },
  data() {
    return {
      btnData: []
    }
  },
  created() {
    // 需要获取路由query上的type，用于区分跳转到不同的撮合管理页面 enquiry 表示 询价 auction 表示 流拍撮合
    let type = this.$route.query.type === 'enquiry'
    // 区分 线索询价撮合还是车辆询价撮合 inquiry 表示线索，auction 表示 车辆
    let source = this.$route.query.source
    let btnData = []
    if (type) {
      // 询价撮合跳转页面
      btnData = [
        {
          link: `/auction/enquiry/manage`,
          name: '撮合管理'
        },
        {
          link: `/inquiry/inquiryInfo/${this.$route.params.id}/${source}`,
          name: '询价信息'
        }
      ]
    } else {
      // 流拍撮合跳转页面
      btnData = [
        { // 评估保存成功页
          link: `/auction/match/manage`,
          name: '撮合管理'
        },
        {
          link: `/auction/offer/${this.$route.params.id}`,
          name: '出价信息'
        }
      ]
    }
    this.btnData = btnData
  }
}

</script>
